import './style/index.js';

import _Card from './card.jsx';

export type { CardProps } from './card.jsx';
export const Card = _Card;
export default Card;

export * from './type';
